/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { APP_CONFIG as CORE_APP_CONFIG } from '@core/config/app-config';
import { AppConfigModel } from '@models/app/app-config.model';
import { EditableParam } from '@core/models/quotation-calculate';

export const APP_CONFIG: AppConfigModel = {
  ...CORE_APP_CONFIG,
  generic: {
    ...CORE_APP_CONFIG.generic,
    errorDisplay: 'page',
    helpLinks: [],
    allowedIbanCountries: ['IT'],
    sendLogs: true,
    notifyIdle: true,
    idleTimeout: 300,
    idleWarningTimeout: 5,
    blockingErrorCodes: ['exception.hawk.retries.exceeded']
  },
  theme: {
    ...CORE_APP_CONFIG.theme,
    logoOnHeader: true,
    logoUrl: 'assets/icons/logo_banca.svg',
    footerPrimaryText: 'btn.continue',
    activeViews: [
      ['LEG_FOO', true],
      ['QUO_PREV_CMP', true],
      ['QUO_PREV_STD', false],
      ['QUO_CONF_INF', true],
      ['UPL_DOC_DESC', true],
      ['QUO_AMOUNT_INPUT_EDITABLE', true],
      ['QUO_DURATION_INPUT_EDITABLE', true]
    ],
    tooltipInterface: 'modal',
    srcAlias: {
      ['./assets/images/INFO_LOAN_PURPOSE-CAR.svg']:
        './assets/images/finality-CAR.svg',
      ['./assets/images/INFO_LOAN_PURPOSE-DBT.svg']:
        './assets/images/finality-DBT.svg',
      ['./assets/images/INFO_LOAN_PURPOSE-HLD.svg']:
        './assets/images/finality-HLD.svg',
      ['./assets/images/INFO_LOAN_PURPOSE-LIQ.svg']:
        './assets/images/finality-LIQ.svg',
      ['./assets/images/INFO_LOAN_PURPOSE-MCP.svg']:
        './assets/images/finality-MCP.svg',
      ['./assets/images/INFO_LOAN_PURPOSE-MEX.svg']:
        './assets/images/finality-MEX.svg',
      ['./assets/images/INFO_LOAN_PURPOSE-RHS.svg']:
        './assets/images/finality-RHS.svg',
      ['./assets/images/INFO_LOAN_PURPOSE-STD.svg']:
        './assets/images/finality-STD.svg',
      ['./assets/images/INFO_LOAN_PURPOSE-WDD.svg']:
        './assets/images/finality-WDD.svg',
      ['./assets/icons/faq.svg']: './assets/icons/faq_2.svg'
    }
  },
  security: {
    ...CORE_APP_CONFIG.security,
    authCodeRequired: false,
    dynamicAuthCodeEngage: true,
    authStrategy: 'header',
    hideSender: true,
    urlOutOfAuth: [
      'assets/i18n',
      'assets/demo',
      'assets/res',
      'api/authenticate',
      'castlemock/mock/rest/project'
    ]
  },
  wizard: {
    ...CORE_APP_CONFIG.wizard,
    startPage: 'first-open-step',
    closingMode: 'wizard',
    nextPage: 'first-open-step',
    avoidBack: true,
    freeNavigation: true,
    progressBar: 'absolute',
    allowStateMenu: true
  },
  upload: {
    ...CORE_APP_CONFIG.upload,
    gridOnPreview: true,
    documentPages: {},
    additionalPages: {
      ['B08']: 14,
      ['B07']: 14,
      ['DOC_IDE']: 14,
      ['B04']: 14,
      ['B79']: 14,
      ['B95']: 14,
      ['B151']: 14,
      ['B152']: 14,
      ['SECCI']: 14
    },
    allowHandover: true,
    compressPicture: true,
    compressQualities: [
      { range: [0, 1], value: 0.9 },
      { range: [1, 2], value: 0.8 },
      { range: [2, Infinity], value: 0.6 }
    ],
    avoidInstructions: false,
    avoidWhichPage: true,
    runScan: true
  },
  form: {
    ...CORE_APP_CONFIG.form,
    stepCodeAsCode: true,
    cleanChildren: true,
    prefillWhenSingleOption: true,
    hideMandatorySign: true,
    dateFormat: 'iso',
    calendarInterface: 'popover',
    selectInterface: 'popover'
  },
  survey: {
    ...CORE_APP_CONFIG.survey,
    alertWhenContinue: false,
    stepCodeAsCode: true,
    hideMandatorySign: true,
    avoidReferenceId: true,
    selectInterface: 'popover'
  },
  dashboard: {
    ...CORE_APP_CONFIG.dashboard
  },
  quotation: {
    ...CORE_APP_CONFIG.quotation,
    primaryData: [
      {
        id: 'requestedAmount',
        title: 'lbl.quotation_upright',
        format: 'currency'
      },
      {
        id: 'duration',
        title: 'lbl.quotation_max_duration',
        format: 'month'
      },
      {
        id: 'installment',
        title: 'lbl.quotation_max_installment',
        format: 'currency'
      },
      { id: 'tan', title: 'lbl.quotation_tan', format: 'perc' },
      { id: 'taeg', title: 'lbl.quotation_taeg', format: 'perc', bold: true }
    ],
    editableParams: [
      EditableParam.instalment,
      EditableParam.amount,
      EditableParam.duration
    ],
    view: 'inline',
    rejectAllowed: false,
    moduleCodes: ['comm-offer', 'pre-contr'],
    moduleCodesToView: ['comm-offer'],
    skipDocumentCheck: true,
    highlightsWhatMissing: true
  },
  publisher: {
    ...CORE_APP_CONFIG.publisher,
    hideExtension: true,
    downloadDirectly: true
  },
  quotationCalculate: {
    ...CORE_APP_CONFIG.quotationCalculate,
    preparationSections: [
      EditableParam.finality,
      EditableParam.amount,
      EditableParam.instalment
    ],
    editableSections: [
      EditableParam.instalment,
      EditableParam.amount,
      EditableParam.duration
    ]
  },
  documentsRequest: {
    ...CORE_APP_CONFIG.documentsRequest
  },
  digitalSignature: {
    ...CORE_APP_CONFIG.digitalSignature,
    signatureExpireError: 'self-digital.signature.session.expired'
  }
};
